import React from 'react'
// libs
import styled from 'styled-components'
import { useSelector } from 'react-redux'
// themes
import { colors } from 'themes/index'
// components
import { ColorSelect } from 'components/FormElements'
// types
import { Forms } from 'constants/forms'
import { IField } from 'types/graphql'
// utils
import { isColorLight } from 'utils/tree'
import { formValueSelector } from 'redux-form'

const Wrapper = styled.div<{ color: string }>`
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 6px;
  margin-top: 6px;
  font-weight: 500;
  color: ${colors.white};
  height: 44px;
  background: ${({ color }) => color};
  color: ${({ color }) => (isColorLight(color) ? colors.black : colors.white)};
`

interface Props {
  property: IField
}

const selector = formValueSelector(Forms.PROPERTY_EDIT_FORM)

const SectionColorSelect: React.FC<Props> = ({ property }) => {
  const color = useSelector((state) => selector(state, 'backgroundColor')) || colors.gray190

  const initialColor = property.backgroundColor || colors.gray190

  return (
    <ColorSelect
      name={'backgroundColor'}
      initialColor={initialColor}
      trigger={<Wrapper color={color}>Set color {color}</Wrapper>}
    />
  )
}

export default SectionColorSelect
